<template lang="pug">
	div
		deliveryFilter
		NothingFound(v-if="!filteredPpnts.length" text="Участников не найдено!")
		b-list-group(v-else)
			b-list-group-item.flex-column.align-items-start(v-for="ppnt in filteredPpnts" :key="ppnt.id")
				div.g-between-center.w-100
					div
						h5.mb-1
							span {{ fullName(ppnt.user||ppnt.dependent_member) }}
							|  ({{ ppnt.reception_letter }}-{{ ppnt.reception_number }})
						small(v-if="ppnt.user")
							div(v-if="ppnt.user.company")  {{ ppnt.user.company.title }}
							div(v-else-if="ppnt.user.organisation")  {{ ppnt.user.organisation }}
						div
							b-badge(variant="primary" style="font-weight:400;") {{ ppnt.stage.title }}
					div
						b-button.mr-2(variant="success" size="sm" :disabled="completeArr.includes(ppnt.id)" @click="fullComplete(ppnt.id)")
							b-spinner.mr-2(small label="Small Spinner" v-if="completeArr.includes(ppnt.id)")
							span Собрано корректно
						b-button.mr-2(variant="warning" size="sm" :disabled="completeArr.includes(ppnt.id)" @click="partlyComplete(ppnt.id)")
							b-spinner.mr-2(small label="Small Spinner" v-if="completeArr.includes(ppnt.id)")
							span Собрано не полностью
						b-button(variant="danger" size="sm" :disabled="removeArr.includes(ppnt.id)" @click="remove(ppnt.id)")
							b-spinner(small label="Small Spinner" v-if="removeArr.includes(ppnt.id)")
							i.fa.fa-close.fa-md(v-else)

</template>

<script>
	import { mapState } from 'vuex'
	import deliveryFilter from '../components/deliveryFilter'


	export default {
		name: 'DeliveryEvent',
		components: {
			deliveryFilter,
		},
		data: () => ({
			removeArr:[],
			completeArr:[],
			fields:['id','user','dependent_member','reception_letter','reception_number','stage','attended','incomplete','delivered','delivered_datetime','denied']
		}),
		computed: {
			...mapState(['page']),
			...mapState({
				participants: state => state.event.participants,
			}),
			filterVal(){ return this.page.participant.filterDelivery.name },
			ppntsList(){
				return (this.participants.data || [])
			},
			ppntsAttended(){
				return this.ppntsList.filter(({attended,incomplete,delivered})=>attended && !incomplete && !delivered)
			},
			filteredPpnts(){
				return this.filterVal
					? this.ppntsAttended.filter( ({user,dependent_member}) => {
						const {first_name,last_name,patronymic} = user || dependent_member;
						return (
							this.isSubStr(first_name,this.filterVal)
							|| this.isSubStr(last_name,this.filterVal)
							|| this.isSubStr(patronymic,this.filterVal)
						)
					}) : this.ppntsAttended;
			},
		},
		methods: {
			fullName({last_name,first_name,patronymic}){ return `${last_name} ${first_name} ${patronymic||''}` },
			isSubStr(str, substr){ return (str ? (str.toLowerCase()).includes(substr.toLowerCase()) : false) },
			refreshPpnts(){
				this.$store.dispatch('getEventParticipants',{id:this.$route.params.id,params:{fields:this.fields}})
			},
			remove(id){
				this.removeArr.push(id);
				this.$store.dispatch('patchParticipant', { id:id, data:{"attended":false}} )
					.then( async () => {
						await this.refreshPpnts();
						await this.removeArr.splice(this.removeArr.indexOf(id),1);
					})
					.catch( error => alert(error) );
			},
			partlyComplete(id){
				this.completeArr.push(id);

				this.$store.dispatch('patchParticipant', { id:id, data:{"incomplete":true,"delivered_datetime":(new Date()).toISOString()}} )
					.then( async () => {
						await this.refreshPpnts();
						await this.completeArr.splice(this.completeArr.indexOf(id),1);
					})
					.catch( error => alert(error) );
			},
			fullComplete(id){
				this.completeArr.push(id);

				this.$store.dispatch('patchParticipant', { id:id, data:{"delivered":true,"delivered_datetime":(new Date()).toISOString()}} )
					.then( async () => {
						await this.refreshPpnts();
						await this.completeArr.splice(this.completeArr.indexOf(id),1);
					})
					.catch( error => alert(error) );
			},
		},
	}
</script>

